/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

// AUTOGENERATED BY glean_parser v14.5.2. DO NOT EDIT. DO NOT COMMIT.

import StringMetricType from '@mozilla/glean/private/metrics/string';
import BooleanMetricType from '@mozilla/glean/private/metrics/boolean';

/**
 * The name of the framework used by the app (ie React or Backbone).
 *
 * Generated from `event.app_framework`.
 */
export const appFramework = new StringMetricType({
  category: 'event',
  name: 'app_framework',
  sendInPings: ['accounts-events'],
  lifetime: 'ping',
  disabled: false,
});

/**
 * the choice made by the user in a given event
 *
 * Generated from `event.choice`.
 */
export const choice = new StringMetricType({
  category: 'event',
  name: 'choice',
  sendInPings: ['accounts-events'],
  lifetime: 'ping',
  disabled: false,
});

/**
 * Whether the user has been enrolled in a CMS customization.
 *
 * Generated from `event.cms_customization_enrollment`.
 */
export const cmsCustomizationEnrollment = new BooleanMetricType({
  category: 'event',
  name: 'cms_customization_enrollment',
  sendInPings: ['accounts-events'],
  lifetime: 'ping',
  disabled: false,
});

/**
 * The name of the event
 *
 * Generated from `event.name`.
 */
export const name = new StringMetricType({
  category: 'event',
  name: 'name',
  sendInPings: ['accounts-events'],
  lifetime: 'ping',
  disabled: false,
});

/**
 * The name of the client ID for Nimbus experiments.
 *
 * Generated from `event.nimbus_user_id`.
 */
export const nimbusUserId = new StringMetricType({
  category: 'event',
  name: 'nimbus_user_id',
  sendInPings: ['accounts-events'],
  lifetime: 'ping',
  disabled: false,
});

/**
 * additional context-dependent (on event.name) info, e.g. the cause of an error
 *
 * Generated from `event.reason`.
 */
export const reason = new StringMetricType({
  category: 'event',
  name: 'reason',
  sendInPings: ['accounts-events'],
  lifetime: 'ping',
  disabled: false,
});

/**
 * boolean, additional context-dependent (on event.name) info related to third
 * party auth links
 *
 * Generated from `event.third_party_links`.
 */
export const thirdPartyLinks = new BooleanMetricType({
  category: 'event',
  name: 'third_party_links',
  sendInPings: ['accounts-events'],
  lifetime: 'ping',
  disabled: false,
});
